import React, { useEffect, useRef, useState } from "react";
import FooterLogo from "../assets/images/banner-logo.svg";
import { config } from "../config";

function Header() {
  const route = window.location.pathname;

  const storeUserVisit = async () => {
    const response = await fetch(`${config.localApiUrl}/api/visitor`);
  }
  useEffect(() => {
    storeUserVisit();
  }, []);

  return (
    <>
      <div className="header">
        <div className="container">
          <div className="header-logo"
            onClick={() => {
              window.location.href = "/";
            }}
          >
            <img src={FooterLogo} alt="" />
          </div>
        </div>
      </div>
    </>
  );
}

export default Header;
